import { render, staticRenderFns } from "./WizardChildcareAllowance.vue?vue&type=template&id=46dbe08c&"
import script from "./WizardChildcareAllowance.vue?vue&type=script&lang=js&"
export * from "./WizardChildcareAllowance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports